import { type ReactElement, type ReactNode } from 'react'
import { Select } from '@base-ui/react/select'
import { Check } from 'lucide-react'
import { twMerge } from 'tailwind-merge'
import {
  listItemCheck,
  listItemDescription,
  listItemLabel,
  listItemStack,
  listItemVariants,
} from '../../../lib/list-styles'

interface SelectItemProps<T> {
  className?: string
  children: ReactNode
  value: T
  icon?: ReactElement
  /** A second line under the label. It wraps, and the row grows to fit. */
  description?: ReactNode
  onClick?: () => void
}

function SelectItem<T>({ className, children, value, icon, description, onClick, ...props }: SelectItemProps<T>) {
  return (
    <Select.Item
      data-slot="list-item"
      value={value}
      onClick={onClick}
      className={twMerge(listItemVariants(), className)}
      {...props}
    >
      {icon}
      {/* Past the list's cap a label ends in an ellipsis; ItemText holds only the label so the
          description never leaks into the trigger or typeahead. */}
      {description ? (
        <span className={listItemStack}>
          <Select.ItemText className="truncate">{children}</Select.ItemText>
          <span data-slot="list-item-description" className={listItemDescription}>
            {description}
          </span>
        </span>
      ) : (
        <Select.ItemText className={listItemLabel}>{children}</Select.ItemText>
      )}
      <Select.ItemIndicator data-slot="list-item-check" className={listItemCheck}>
        <Check />
      </Select.ItemIndicator>
    </Select.Item>
  )
}

export { SelectItem }
